<gb-payment-stepper *ngIf="!(paymentSessionExpired$ | async); else paymentExpired"></gb-payment-stepper>

<ng-template #paymentExpired><gb-payment-expired></gb-payment-expired></ng-template>
